module.exports = __webpack_public_path__ + "img/ServicioAutomotriz.d2cb160f.png";